/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum BundleSettlementsColumnEnum {
    SUPPLIER = 'SUPPLIER',
    COMPLAINT_CODE = 'COMPLAINT_CODE',
    SETTLEMENT_CODE = 'SETTLEMENT_CODE',
    PARTS_TOTAL_NET_COST = 'PARTS_TOTAL_NET_COST',
    PARTS_TOTAL_GROSS_COST = 'PARTS_TOTAL_GROSS_COST',
    TE_MINUTES_TOTAL_COST = 'TE_MINUTES_TOTAL_COST'
}
